export enum MailsTasksStatusEnum {
  created = "created",
  processed = "processed",
  failed = "failed",
}
